import {QueryLangFilterOperator} from '../../../enums/query-lang-filter-operator';
import {QueryLangFilterCriterionInput} from '../../../models/filters/query-lang-filter-criterion-input';

export class FilterTxByAddressInput extends QueryLangFilterCriterionInput {
    public override fieldNames: string[] = ['order.address', 'transaction.from'];
    public placeholder = 'Address'; // TODO: locale
    public override name = 'filter-tx-by-address';
    public override operator = QueryLangFilterOperator.IN;

    private userWalletAddresses: string[];

    public override getPrimitiveQueryValue(): string {
        return this.query
            ? this.query
            : (this.userWalletAddresses || []).join(',');
    }

    public override isQuerySpecified(): boolean {
        return true; // Always filter: either by specified address or by user wallets
    }

    public updateUserWallets(addresses: string[]): void {
        this.userWalletAddresses = addresses;
    }

}
